"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePeriods = calculatePeriods;
function calculatePeriods(items, callback, endDate) {
    return items.map((item, index, array) => {
        const from = callback(item);
        let nextDate = undefined;
        for (let i = index + 1; i < array.length; i++) {
            const next = callback(array[i]);
            if (next.getTime() > from.getTime()) {
                nextDate = new Date(next.getFullYear(), next.getMonth(), next.getDate() - 1);
                break;
            }
        }
        return { item, from, to: nextDate || endDate };
    });
}
//# sourceMappingURL=PeriodCalculator.js.map